var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 97,
    viewBox: "0 0 135 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6919 48.2838C18.2948 31.2944 36.8348 19.3617 53.1074 28.6867C58.4682 31.7587 63.019 36.3086 67.9122 41.2778C68.1347 41.5038 68.2374 41.4804 68.4456 41.2706C76.0992 33.5553 87.1812 21.7908 102.704 26.368C109.236 28.2943 113.775 32.5325 116.101 38.9188C123.884 60.2929 101.558 77.989 82.412 66.2583C77.5831 63.2996 73.4129 59.2171 68.4836 54.1969C68.2204 53.9289 68.1017 53.9668 67.8612 54.2094C62.2609 59.8568 56.2327 65.9953 48.7868 68.5652C33.6349 73.7945 19.1097 64.7656 18.6919 48.2838ZM28.1732 47.9544C28.6563 57.7683 36.2053 62.3433 44.2486 60.6036C51.1997 59.1001 57.0309 52.9867 61.9975 47.8812C62.1648 47.7092 62.071 47.6393 61.956 47.532C57.6423 43.5055 53.4296 38.587 48.1204 36.0559C37.8305 31.1503 28.1386 38.3445 28.1732 47.9544ZM108.183 47.5397C107.877 38.0553 100.394 32.8868 91.7721 34.9093C84.988 36.5005 79.1909 42.585 74.3745 47.5337C74.2074 47.7054 74.2716 47.7855 74.4085 47.9133C80.4305 53.5331 87.5368 62.4061 97.138 60.789C103.533 59.7118 108.197 54.1414 108.183 47.5397Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.d099870a8639593717e3b17aea138c92.svg";
export { ForwardRef as ReactComponent };